import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  overflow: hidden;
  padding: 1rem;
  gap: 1rem;
  align-items: stretch;
  height: 100%;

  & > div {
    flex: 1;
  }

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
